export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center pt-[72px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20arrangement%20of%20diverse%20fashion%20products%20including%20colorful%20sneakers%20folded%20hoodies%20sunglasses%20and%20accessories%20spread%20across%20a%20warm%20cream%20linen%20surface%2C%20soft%20diffused%20natural%20window%20light%2C%20editorial%20lifestyle%20photography%2C%20gentle%20pastel%20accents%2C%20clean%20airy%20composition%2C%20neutral%20beige%20backdrop%2C%20elegant%20modern%20minimal%20aesthetic%2C%20warm%20inviting%20atmosphere&width=1600&height=900&seq=hero-bg-v2&orientation=landscape"
          alt="Superbuy Spreadsheet shopping lifestyle with fashion products arranged on warm minimal surface"
          title="Superbuy Spreadsheet — Smart Shopping Sheets"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/40 via-background-50/30 to-background-50/60"></div>
      </div>

      <div className="relative w-full px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20 max-w-7xl mx-auto">
          <div className="flex-1 text-center lg:text-left">
            <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-foreground-950 leading-[1.05] tracking-tight">
              Your Global<br />
              <span className="text-primary-500">Shopping Sheet</span>
            </h1>
            <p className="mt-6 text-base md:text-lg text-foreground-600 max-w-lg mx-auto lg:mx-0 leading-relaxed">
              Discover the best products across 14 curated categories. Smart shopping sheets for faster, smarter global sourcing — trusted by thousands of buyers worldwide.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap flex items-center justify-center gap-2 cursor-pointer group"
              >
                Buy It Now
                <span className="w-5 h-5 rounded-full bg-background-50/20 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                  <i className="ri-arrow-right-line text-xs text-background-50"></i>
                </span>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 border-2 border-foreground-800 text-foreground-800 rounded-full text-sm font-semibold hover:bg-foreground-800 hover:text-background-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Superbuy Sheet
              </a>
            </div>
          </div>

          <div className="flex-1 hidden lg:block">
            <div className="relative">
              <div className="w-full aspect-[4/5] rounded-3xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20vertical%20composition%20showcasing%20premium%20fashion%20items%20including%20designer%20sneakers%20a%20cashmere%20hoodie%20and%20leather%20accessories%20styled%20on%20a%20marble%20shelf%20against%20a%20warm%20cream%20wall%2C%20soft%20natural%20window%20light%20from%20the%20right%2C%20editorial%20luxury%20product%20photography%2C%20sophisticated%20minimal%20aesthetic%2C%20gentle%20shadows%2C%20refined%20warm%20neutral%20color%20palette&width=800&height=900&seq=hero-side-v2&orientation=portrait"
                  alt="Curated fashion products displayed with Superbuy Spreadsheet"
                  title="Superbuy Spreadsheet product curation"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute top-4 left-4 bg-background-50/90 backdrop-blur-sm px-4 py-2 rounded-full">
                <span className="text-xs font-semibold text-foreground-700">Superbuy Spreadsheet</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 text-center">
          <a
            href="#categories"
            className="inline-flex flex-col items-center gap-2 text-foreground-400 hover:text-foreground-700 transition-colors"
          >
            <span className="text-xs font-medium uppercase tracking-widest">Explore 14 Categories</span>
            <i className="ri-arrow-down-line text-lg animate-bounce"></i>
          </a>
        </div>
      </div>
    </section>
  );
}